import {notification} from 'antd';
export function notificationSucces(message: string, description?: string) {
    notification.success({
        message,
        description: description || '',
        placement: 'bottomRight'
    })
}
export function notificationError(message: string, description?: string) {
    notification.error({
        message,
        description: description || '',
        placement: 'bottomRight'
    })
}

(<any>window).notificationSucces = (message: string) => {notificationSucces(message)}
(<any>window).notificationError = (message: string) => {notificationError(message)}